export default __webpack_public_path__ + "static/media/teams.d07bc7ff.svg";